/**
 * Expressive motion: tells pupil-fill buttons where the pointer or finger is, so their circular fill
 * grows from that point (snippets/motion-plus-styles.liquid reads --px / --py). One delegated
 * listener for the whole page, so buttons added later (cart drawer, quick add) work too.
 */

const BUTTON_SELECTOR = [
  '.buttons-editorial .button:not(.button-unstyled, .header-actions__action)',
  '.buttons-editorial .button-secondary',
  '.buttons-editorial .button-custom',
  '.atelier-hero__cta',
].join(',');

/**
 * @param {PointerEvent} event
 */
function trackPointer(event) {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest(BUTTON_SELECTOR);
  if (!(button instanceof HTMLElement)) return;
  const rect = button.getBoundingClientRect();
  button.style.setProperty('--px', `${event.clientX - rect.left}px`);
  button.style.setProperty('--py', `${event.clientY - rect.top}px`);
}

if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.addEventListener('pointerover', trackPointer, { passive: true });
  document.addEventListener('pointerdown', trackPointer, { passive: true });
}
